import { render, staticRenderFns } from "./SettingsBlock.vue?vue&type=template&id=470f82ba&scoped=true"
import script from "./SettingsBlock.vue?vue&type=script&lang=js"
export * from "./SettingsBlock.vue?vue&type=script&lang=js"
import style0 from "./SettingsBlock.vue?vue&type=style&index=0&id=470f82ba&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "470f82ba",
  null
  
)

export default component.exports